import { createElement } from 'react';
import PropTypes from 'prop-types';

import { wrapper } from './ContentWrapper.less';

const ContentWrapper = ({ children }) => createElement('div', { className: wrapper }, children);

ContentWrapper.propTypes = { children: PropTypes.node };

export default ContentWrapper;
